// 首页可配置模块分配数据
import * as React from 'react'
import HomeLimitBar from '../HomeLimitBar/HomeLimitBar'
import { HomePictureView } from '../HomePictureView/HomePictureView'
import HomeStackBlock from '../HomeStackBlock/HomeStackBlock'
import HomeCardView from '../HomeCardView/HomeCardView'
import HomeType from '../../types/HomeType'
import { HomeRankingModule } from '../HomeRankingModule/HomeRankingModule'
import { HomeChoiceness } from '../HomeChoiceness/HomeChoiceness'
import { HomeSlideLecture } from '../HomeSlideLecture/HomeSlideLecture'
import { HomeRankingModuleSpecial } from '../TriennialsSpecial/HomeRankingModule/HomeRankingModule'

interface HomeConfigurationModuleProps {
    content: HomeType.Module[]
}

// HomeModuleReportWrap 监测埋点上报装饰器

function HomeConfigurationModule(props: HomeConfigurationModuleProps) {
        const {content} = props
        return (
            <div>
                {content.length > 0 && content.map((item: HomeType.Module, index: any) => {
                    switch (item.module_style) {
                        case '1' :
                            return <HomeLimitBar data={item} key={index}/> /*限时秒杀模块*/
                        case '2' :
                            return  <HomePictureView data={item} key={index} invite_id={item.invite_id} moduleid={item.id} moduleStyle={item.module_style}/> /*混合模块 双图 文章列表 + 图文*/
                        case '3' :
                            return  <HomeCardView data={item} key={index} moduleid={item.id} /> /*卡片文章列表*/
                        case '4' :
                            return  <HomeStackBlock data={item} key={index}/> /*封面图模式*/
                        case '9':
                            return  <HomeChoiceness data={item} key={index}/>/* 精选课程 */
                        case '10':
                            if (item.is_anniversary && item.is_anniversary === true) { // 历史需求，通过这个参数分辨是不是周年活动的模块
                                return  <HomeRankingModuleSpecial data={item} key={index} invite_id={item.invite_id}/> /* 试听模块 */
                            } else {
                                return  <HomeRankingModule data={item} key={index} /> /* 试听模块 */
                            }
                        case '11':
                            return <HomeSlideLecture data={item} key={index}/> /* 滑动课程模块 */
                        case '13':
                            return <HomePictureView data={item} key={index} invite_id={item.invite_id} moduleStyle={item.module_style}/> /*混合模块 双图 文章列表 + 图文*/
                        default:
                            return ''
                     }
                })}
            </div>
        )
}

export default HomeConfigurationModule



// WEBPACK FOOTER //
// ./src/views/Home/components/HomeConfigurationModule/HomeConfigurationModule.tsx